<template>
  <div>
    <div class="coverShow" v-show="viseable">
      <div class="container-gj" @click.stop>
        <div class="container-gd" @click.stop>
          <div class="header">
            <p>{{ operate == "0" ? "添加题目" : "修改题目" }}</p>
            <i
              class="fa-solid fa-circle-xmark"
              style="color: #8290a3; cursor: pointer"
              @click="handleCloseClick"
            ></i>
          </div>
          <div style="display: flex; align-items: center; margin-top: 15px">
            <el-select
              v-model="libraryName"
              placeholder="请选择"
              style="
                width: 191px;
                background: #f7f7f7;
                border: 1px solid #ededed;
                margin-left: 20px;
              "
              :disabled="operate == '1'"
              @change="handleLibraryChange"
            >
              <el-option
                v-for="item in libraryList"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <div v-if="operate == '1'" class="type-div">
              {{ getTypeString(dataObj.type) }}
            </div>
          </div>
          <div v-if="operate == '0'" class="type-list">
            <div
              v-for="(item, index) in dataList"
              :key="index"
              :class="[
                typeActive == item.value
                  ? 'type-item-active'
                  : 'type-item-inactive',
              ]"
              @click="handleItemClick(item)"
            >
              {{ item.label }}
            </div>
          </div>
          <div class="item-container">
            <div class="item" v-if="typeActive == QuestionType.SCQ">
              <QuestionEditSCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MCQ">
              <QuestionEditMCQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMCQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SBQ">
              <QuestionEditSBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MBQ">
              <QuestionEditMBQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMBQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DLQ">
              <QuestionEditDLQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditDLQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NPS">
              <QuestionEditNPS
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditNPS>
            </div>
            <div class="item" v-if="typeActive == QuestionType.QA">
              <QuestionEditQA
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditQA>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SRQ">
              <QuestionEditSRQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSRQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.VOTE">
              <QuestionEditVote
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditVote>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SORT">
              <QuestionEditSort
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditSort>
            </div>
            <div class="item" v-if="typeActive == QuestionType.SCORE">
              <QuestionEditScore
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditScore>
            </div>
            <div class="item" v-if="typeActive == QuestionType.WRQ">
              <QuestionEditWRQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditWRQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.REMARK">
              <QuestionEditRemark
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditRemark>
            </div>
            <div class="item" v-if="typeActive == QuestionType.NAME">
              <QuestionEditName
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditName>
            </div>
            <div class="item" v-if="typeActive == QuestionType.GENDER">
              <QuestionEditGender
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditGender>
            </div>
            <div class="item" v-if="typeActive == QuestionType.AGE">
              <QuestionEditAge
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAge>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TEL">
              <QuestionEditTel
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTel>
            </div>
            <div class="item" v-if="typeActive == QuestionType.EMAIL">
              <QuestionEditEmail
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditEmail>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DATE">
              <QuestionEditDate
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditDate>
            </div>
            <div class="item" v-if="typeActive == QuestionType.TIME">
              <QuestionEditTime
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditTime>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ADDR">
              <QuestionEditAddress
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditAddress>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IMAGE">
              <QuestionEditImage
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditImage>
            </div>
            <div class="item" v-if="typeActive == QuestionType.MaxDiff">
              <QuestionEditMaxDiff
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditMaxDiff>
            </div>
            <div class="item" v-if="typeActive == QuestionType.UploadFile">
              <QuestionEditUploadFile
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditUploadFile>
            </div>
            <div class="item" v-if="typeActive == QuestionType.DownloadFile">
              <QuestionEditDownloadFile
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditDownloadFile>
            </div>
            <div class="item" v-if="typeActive == QuestionType.CASCADER">
              <QuestionEditCASCADER
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId + ''"
                @update="updateQuestionClick"
              ></QuestionEditCASCADER>
            </div>
            <!-- <div class="item" v-if="typeActive == QuestionType.ClozeTest">
              <QuestionEditClozeTest
                :params="dataObj"
                :index="0"
                :type="2"
                @update="updateQuestionClick"
              ></QuestionEditClozeTest>
            </div> -->
            <div class="item" v-if="typeActive == QuestionType.BDQ">
              <QuestionEditBDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditBDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.IDQ">
              <QuestionEditIDQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditIDQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.ELQ">
              <QuestionEditELQ
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditELQ>
            </div>
            <div class="item" v-if="typeActive == QuestionType.WX">
              <QuestionEditWX
                :params="dataObj"
                :index="0"
                :type="2"
                :uuid="libraryId"
                @update="updateQuestionClick"
              ></QuestionEditWX>
            </div>
          </div>
          <div class="confirm-btn" @click="handleConfirmClick">
            {{ operate == "0" ? "确认添加" : "确认修改" }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { createPCUserLibraryQuestion, userLibraryList } from "@/api/index.js";

import QuestionEditSCQ from "@/components/QuestionEdit/QuestionEditSCQ.vue";
import QuestionEditMCQ from "@/components/QuestionEdit/QuestionEditMCQ.vue";
import QuestionEditDLQ from "@/components/QuestionEdit/QuestionEditDLQ.vue";
import QuestionEditVote from "@/components/QuestionEdit/QuestionEditVote.vue";
import QuestionEditSort from "@/components/QuestionEdit/QuestionEditSort.vue";
import QuestionEditSBQ from "@/components/QuestionEdit/QuestionEditSBQ.vue";
import QuestionEditMBQ from "@/components/QuestionEdit/QuestionEditMBQ.vue";
import QuestionEditQA from "@/components/QuestionEdit/QuestionEditQA.vue";
import QuestionEditGender from "@/components/QuestionEdit/QuestionEditGender.vue";
import QuestionEditAge from "@/components/QuestionEdit/QuestionEditAge.vue";
import QuestionEditNPS from "@/components/QuestionEdit/QuestionEditNPS.vue";
import QuestionEditRemark from "@/components/QuestionEdit/QuestionEditRemark.vue";
import QuestionEditScore from "@/components/QuestionEdit/QuestionEditScore.vue";
import QuestionEditName from "@/components/QuestionEdit/QuestionEditName.vue";
import QuestionEditEmail from "@/components/QuestionEdit/QuestionEditEmail.vue";
import QuestionEditTel from "@/components/QuestionEdit/QuestionEditTel.vue";
import QuestionEditTime from "@/components/QuestionEdit/QuestionEditTime.vue";
import QuestionEditDate from "@/components/QuestionEdit/QuestionEditDate.vue";
import QuestionEditWRQ from "@/components/QuestionEdit/QuestionEditWRQ.vue";
import QuestionEditSRQ from "@/components/QuestionEdit/QuestionEditSRQ.vue";
import QuestionEditAddress from "@/components/QuestionEdit/QuestionEditAddress.vue";
import QuestionEditImage from "@/components/QuestionEdit/QuestionEditImage.vue";
import QuestionEditMaxDiff from "@/components/QuestionEdit/QuestionEditMaxDiff.vue";
import QuestionEditUploadFile from "@/components/QuestionEdit/QuestionEditUploadFile.vue";
import QuestionEditDownloadFile from "@/components/QuestionEdit/QuestionEditDownloadFile.vue";
import QuestionEditCASCADER from "@/components/QuestionEdit/QuestionEditCASCADER.vue";
import QuestionEditBDQ from "@/components/QuestionEdit/QuestionEditBDQ.vue";
import QuestionEditIDQ from "@/components/QuestionEdit/QuestionEditIDQ.vue";
import QuestionEditELQ from "@/components/QuestionEdit/QuestionEditELQ.vue";
import QuestionEditWX from "@/components/QuestionEdit/QuestionEditWX.vue";

export default {
  components: {
    QuestionEditSCQ,
    QuestionEditMCQ,
    QuestionEditDLQ,
    QuestionEditVote,
    QuestionEditSort,
    QuestionEditSBQ,
    QuestionEditMBQ,
    QuestionEditQA,
    QuestionEditGender,
    QuestionEditAge,
    QuestionEditNPS,
    QuestionEditRemark,
    QuestionEditScore,
    QuestionEditName,
    QuestionEditEmail,
    QuestionEditTel,
    QuestionEditTime,
    QuestionEditDate,
    QuestionEditWRQ,
    QuestionEditSRQ,
    QuestionEditAddress,
    QuestionEditImage,
    QuestionEditMaxDiff,
    QuestionEditUploadFile,
    QuestionEditDownloadFile,
    QuestionEditCASCADER,
    QuestionEditBDQ,
    QuestionEditIDQ,
    QuestionEditELQ,
    QuestionEditWX,
  },
  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    params: {
      type: Object,
      default: null,
    },
    uuid: {
      type: String,
      default: "",
    },
    operate: {
      type: String,
      default: "0", // 0添加 1编辑
    },
  },
  data() {
    return {
      viseable: false,
      loading: null,
      QuestionType: this.$store.getters["question/getQuestionType"],
      options: [
        {
          value: "1",
          label: "全部",
        },
        {
          value: "2",
          label: "我的",
        },
        {
          value: "3",
          label: "收藏",
        },
      ],
      value: "",
      dataList: [
        {
          value: "1",
          label: "单选题",
          data: {
            type: 1,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                  jump_title: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
          },
        },
        {
          value: "2",
          label: "多选",
          data: {
            type: 2,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              maxCount: 1,
              minCount: 1,
            }),
            status: "0",
          },
        },
        {
          value: "3",
          label: "填空",
          data: {
            type: 3,
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            fillSymbol: 3, // 填空符数量
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            status: "0",
          },
        },
        {
          value: "4",
          label: "多项填空",
          data: {
            type: 4, // 多项填空
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
                {
                  text: "",
                  img_path: [],
                },
              ],
            }),
            status: "0",
          },
        },
        {
          value: "5",
          label: "下拉",
          data: {
            type: 5, // 下拉类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                },
                {
                  text: "",
                },
                {
                  text: "",
                },
              ],
              value: "",
            }),
            status: "0",
          },
        },
        {
          value: "6",
          label: "NPS",
          data: {
            type: 6, // NPS类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), //题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "7",
          label: "投票",
          data: {
            type: 7, // 投票类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            ifShowResult: 0, // 0 不展示 1 展示
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          },
        },
        {
          value: "8",
          label: "排序",
          data: {
            type: 8, // 排序类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  isChoose: true,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 3, //统一格式的话 有几项就得填几项 前端决定
            }),
            status: "0",
          },
        },
        {
          value: "9",
          label: "备注",
          data: {
            type: 9, // 备注类型
            caseProblem: "",
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "10",
          label: "分数评定",
          data: {
            type: 10, // 分数评定类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            minScore: 1, // 起始分数
            scoreNum: 5, // 评分数量
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意", "一般", "非常满意"],
                },
              ],
            }),
            status: "0",
          },
        },
        {
          value: "11",
          label: "问答",
          data: {
            type: 11, // 问答题
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "12",
          label: "权重评分",
          data: {
            type: 12, // 权重评分类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
                {
                  text: "",
                  score: 1,
                },
              ],
            }),
            status: "0",
          },
        },
        {
          value: "13",
          label: "评星",
          data: {
            type: 13, // 评星类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            scoreNum: 5, // 最高分
            starRatingStyle: "1", // 评星样式 前端定 字符串类型
            // elseConfig: JSON.stringify(["非常不满意", "一般", "非常满意"]),
            chooseList: JSON.stringify({
              list: [
                {
                  text: "",
                  ratingArr: ["非常不满意", "一般", "非常满意"],
                },
              ],
            }),
            status: "0",
          },
        },
        {
          value: "14",
          label: "姓名",
          data: {
            type: 14, // 姓名
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "15",
          label: "性别",
          data: {
            type: 15,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "男",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "女",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          },
        },
        {
          value: "16",
          label: "年龄",
          data: {
            type: 16,
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "18岁以下",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0, //是否填空 0否 1是
                  fill_prompt: "",
                },
                {
                  text: "18~35岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "35~60岁",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
                {
                  text: "60岁以上",
                  isChoose: false,
                  img_path: [],
                  is_fill: 0,
                  fill_prompt: "",
                },
              ],
              count: 1, //单选多选
            }),
            status: "0",
          },
        },
        {
          value: "17",
          label: "电话号",
          data: {
            type: 17, // 手机号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            isOnly: 0, // 0 是否唯一  0否 1是
            status: "0",
          },
        },
        {
          value: "18",
          label: "邮箱",
          data: {
            type: 18, // 邮箱
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "19",
          label: "日期",
          data: {
            type: 19, // 日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "20",
          label: "时间",
          data: {
            type: 20, // 时间
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "21",
          label: "地址",
          data: {
            type: 21, // 地址类型
            caseProblem: "", // 题目
            mapAccuracy: 3, // 0 选择地址精度 1 精确到省 2 精确到市 3 精确到区 4 精确到详细地址
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", //  逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "23",
          label: "上传图片",
          data: {
            type: 23, // 图片上传类型
            caseProblem: "", // 题目
            caseProblemImg: JSON.stringify([]), // 题目图片["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            pictureNum: 6, // 图片数量
            status: "0",
          },
        },
        {
          value: "24",
          label: "MaxDiff",
          data: {
            type: 24,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({
              list: [
                {
                  id: "1",
                  context: "属性1",
                },
                {
                  id: "2",
                  context: "属性2",
                },
                {
                  id: "3",
                  context: "属性3",
                },
              ],
              tasksNum: 6,
              attributesNum: 3,
              percentageTitle: "满意,不满意",
              count: 1,
            }),
            status: "0",
          },
        },
        {
          value: "25",
          label: "上传文件",
          data: {
            type: 25,
            caseProblem: "请上传文件",
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            status: "0",
          },
        },
        {
          value: "26",
          label: "下载文件",
          data: {
            type: 26,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({ list: [] }),
            status: "0",
          },
        },
        {
          value: "27",
          label: "联级题",
          data: {
            type: 27,
            caseProblem: "请输入题目说明",
            ifRandomize: 0,
            caseProblemImg: JSON.stringify([]),
            isMust: 1,
            chooseList: JSON.stringify({
              options: [
                {
                  label: "一级选项",
                  children: [
                    {
                      label: "二级选项1",
                      children: [],
                    },
                  ],
                },
              ],
            }),
            elseConfig: "一级标题名称,二级标题名称",
            status: "0",
          },
        },
        {
          value: "29",
          label: "出生日期",
          data: {
            type: 29, // 出生日期
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "30",
          label: "身份证号",
          data: {
            type: 30, // 身份证号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
        {
          value: "31",
          label: "学历",
          data: {
            type: 31, // 学历
            caseProblem: "", // 题目
            ifRandomize: 0, // 是否随机排列   0否 1是
            caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id,下一道题的id)
            chooseList: JSON.stringify({
              list: [
                {
                  text: "初中及以下",
                },
                {
                  text: "高中/中专/技校",
                },
                {
                  text: "大学专科",
                },
                {
                  text: "大学本科",
                },
                {
                  text: "硕士及以上",
                },
              ],
            }),
            status: "0",
          },
        },
        {
          value: "32",
          label: "微信号",
          data: {
            type: 32, // 微信号
            caseProblem: "", // 题目
            isMust: 1, // 是否必填  0否 1是
            logicalJump: "", // 逻辑设置(question_id)
            status: "0",
          },
        },
      ],
      typeActive: 1,
      dataObj: {
        type: 1,
        caseProblem: "", // 题目
        ifRandomize: 0, // 是否随机排列   0否 1是
        caseProblemImg: JSON.stringify([]), // 题目图片 ["img地址"]
        isMust: 1, // 是否必填  0否 1是
        logicalJump: "", // 逻辑设置(question_id,下一道题的id)
        chooseList: JSON.stringify({
          list: [
            {
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0, //是否填空 0否 1是
              fill_prompt: "",
              jump_title: "",
            },
            {
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0,
              fill_prompt: "",
              jump_title: "",
            },
            {
              text: "",
              isChoose: false,
              img_path: [],
              is_fill: 0,
              fill_prompt: "",
              jump_title: "",
            },
          ],
          count: 1, //单选多选
        }),
        status: "0", // 0创建页编辑中 1创建页显示操作 2创建页预览 3详情页预览 4详情页答题
      },
      libraryList: [],
      libraryId: "",
      libraryName: "",
    };
  },
  mounted() {
    this.getLibraryList();
  },
  methods: {
    handleCloseClick() {
      this.$emit("closeDialog");
    },
    handleLibraryChange(val) {
      this.libraryId = val;
      this.libraryName = this.libraryList.find(
        (item) => item.id === val
      ).libraryName;
    },
    handleItemClick(item) {
      this.typeActive = parseInt(item.value);
      this.dataObj = JSON.parse(JSON.stringify(item.data));
    },
    updateQuestionClick(e) {
      console.log("updateQuestionClick", e);
      this.dataObj = JSON.parse(JSON.stringify(JSON.parse(e).data));
    },
    handleConfirmClick() {
      // console.log("dataObj222222222", this.dataObj, this.uuid);
      var params = this.checkRequired(this.dataObj);
      params.libraryId = this.libraryId;
      params.libraryName = this.libraryName;
      params.questionType = "1";
      console.log("e912yryr29ry12r12921t2981ey1298e1298e", params);

      this.$emit("closeDialog");
      this.loading = this.$loading({
        lock: true,
        text: "加载中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      createPCUserLibraryQuestion(params)
        .then((res) => {
          this.loading.close();
          if (res.code == 200) {
            this.$message({
              message: "添加成功",
              type: "success",
            });
            this.$emit("success", this.libraryId);
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: "error",
          });
        });
    },
    checkRequired(obj) {
      this.$message.closeAll();
      switch (obj.type) {
        case this.QuestionType.SCQ:
          const list1 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list1.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.MCQ:
          const list2 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list2.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
            minCount: JSON.parse(obj.chooseList).minCount,
            maxCount: JSON.parse(obj.chooseList).maxCount,
          });
          return obj;
        case this.QuestionType.SBQ:
          console.log("obj1111111111111111", obj);
          if (obj.caseProblem == "") {
            this.$message({
              type: "error",
              message: "题目不能为空",
              offset: "150",
            });
            return;
          } else if (!obj.caseProblem.includes("____")) {
            this.$message({
              type: "error",
              message: "请插入填空符",
              offset: "150",
            });
            return;
          }
          return obj;
        case this.QuestionType.MBQ:
          const list3 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写以下内容" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list3.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? "请输入" : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.DLQ:
          const list4 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list4.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NPS:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您向朋友或同事推荐我们的可能性有多大"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.VOTE:
          const list5 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list5.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SORT:
          const list6 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给以下选项排序" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list6.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.REMARK:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "请阅读本项说明，然后回答问题"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.SCORE:
          const list7 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择一个选项" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list7.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.QA:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写问答题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.WRQ:
          const list8 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list8.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.SRQ:
          const list9 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "请给本项打分" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list9.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `打分项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.NAME:
          obj.caseProblem = obj.caseProblem === "" ? "姓名" : obj.caseProblem;
          return obj;
        case this.QuestionType.GENDER:
          const list10 = JSON.parse(obj.chooseList).list;
          obj.caseProblem = obj.caseProblem === "" ? "性别" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list10.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.AGE:
          const list11 = JSON.parse(obj.chooseList).list;
          obj.caseProblem =
            obj.caseProblem === "" ? "您的年龄是" : obj.caseProblem;
          obj.chooseList = JSON.stringify({
            list: list11.map((item, index) => {
              item.is_fill = item.is_fill ? 1 : 0;
              item.text = item.text === "" ? `选项${index + 1}` : item.text;
              return item;
            }),
          });
          return obj;
        case this.QuestionType.TEL:
          obj.caseProblem = obj.caseProblem === "" ? "手机号" : obj.caseProblem;
          return obj;
        case this.QuestionType.EMAIL:
          obj.caseProblem = obj.caseProblem === "" ? "邮箱" : obj.caseProblem;
          return obj;
        case this.QuestionType.DATE:
          obj.caseProblem = obj.caseProblem === "" ? "日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.TIME:
          obj.caseProblem = obj.caseProblem === "" ? "时间" : obj.caseProblem;
          return obj;
        case this.QuestionType.ADDR:
          obj.caseProblem = obj.caseProblem === "" ? "地址" : obj.caseProblem;
          return obj;
        case this.QuestionType.IMAGE:
          obj.caseProblem =
            obj.caseProblem === "" ? "上传图片回答问题" : obj.caseProblem;
          return obj;
        case this.QuestionType.MaxDiff:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目" : obj.caseProblem;
          return obj;
        case this.QuestionType.UploadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请上传文件" : obj.caseProblem;
          return obj;
        case this.QuestionType.DownloadFile:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.CASCADER:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入题目说明" : obj.caseProblem;
          return obj;
        case this.QuestionType.BDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请选择出生日期" : obj.caseProblem;
          return obj;
        case this.QuestionType.IDQ:
          obj.caseProblem =
            obj.caseProblem === "" ? "请输入身份证号" : obj.caseProblem;
          return obj;
        case this.QuestionType.ELQ:
          obj.caseProblem =
            obj.caseProblem === ""
              ? "您的最高学历() 包括在读是？"
              : obj.caseProblem;
          return obj;
        case this.QuestionType.WX:
          obj.caseProblem =
            obj.caseProblem === "" ? "请填写微信号" : obj.caseProblem;
          return obj;
        default:
          break;
      }
    },
    getLibraryList() {
      userLibraryList({
        libraryType: "1",
      })
        .then((res) => {
          console.log("==============1", res);
          if (res.code === 200) {
            console.log("【】【】【】wewqepqwpeqw", this.uuid);

            this.libraryList = res.data.map((item) => {
              return {
                label: item.libraryName,
                value: item.id,
              };
            });
            if (this.uuid != "") {
              for (let i = 0; i < this.libraryList.length; i++) {
                const element = this.libraryList[i];
                if (element.value == this.uuid) {
                  this.libraryId = element.value;
                  this.libraryName = element.label;
                }
              }
            } else {
              this.libraryId = res.data[0].id;
              this.libraryName = res.data[0].libraryName;
            }
          } else {
            this.$message({
              message: res.msg,
              type: "error",
            });
          }
          console.log("i912u9ry18r2189r21yr981", this.libraryId);
        })
        .catch((err) => {});
    },
    getTypeString(type) {
      switch (type) {
        case this.QuestionType.SCQ:
          return "单选";
        case this.QuestionType.MCQ:
          return "多选";
        case this.QuestionType.SBQ:
          return "填空";
        case this.QuestionType.MBQ:
          return "多项填空";
        case this.QuestionType.DLQ:
          return "下拉";
        case this.QuestionType.NPS:
          return "NPS";
        case this.QuestionType.VOTE:
          return "投票";
        case this.QuestionType.SORT:
          return "排序";
        case this.QuestionType.REMARK:
          return "备注";
        case this.QuestionType.SCORE:
          return "分数评定";
        case this.QuestionType.QA:
          return "问答";
        case this.QuestionType.WRQ:
          return "权重评分";
        case this.QuestionType.SRQ:
          return "评星";
        case this.QuestionType.NAME:
          return "姓名";
        case this.QuestionType.GENDER:
          return "性别";
        case this.QuestionType.AGE:
          return "年龄";
        case this.QuestionType.TEL:
          return "电话号";
        case this.QuestionType.EMAIL:
          return "邮箱";
        case this.QuestionType.DATE:
          return "日期";
        case this.QuestionType.TIME:
          return "时间";
        case this.QuestionType.ADDR:
          return "地址";
        case this.QuestionType.TFQ:
          return "判断题";
        case this.QuestionType.IMAGE:
          return "图片";
        case this.QuestionType.MaxDiff:
          return "MaxDiff题";
        case this.QuestionType.UploadFile:
          return "上传文件";
        case this.QuestionType.DownloadFile:
          return "下载文件";
        case this.QuestionType.CASCADER:
          return "联级题";
        case this.QuestionType.BDQ:
          return "出生日期";
        case this.QuestionType.IDQ:
          return "身份证号";
        case this.QuestionType.ELQ:
          return "学历";
        case this.QuestionType.WX:
          return "微信号";
      }
    },
  },
  watch: {
    showDialog(newVal) {
      this.viseable = newVal;
      if (this.params != null) {
        this.dataObj = this.params;
        this.typeActive = this.dataObj.type;
      } else {
        this.typeActive = this.QuestionType.SCQ;
        this.dataObj = JSON.parse(JSON.stringify(this.dataList[0].data));
      }
      this.getLibraryList();
    },
    uuid: {
      handler(newVal, oldVal) {
        this.libraryId = newVal;
      },
      immediate: true,
    },
  },
};
</script>

<style scoped>
.flexs {
  display: flex;
}

.paddings {
  padding: 0;
}

.coverShow {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.container-gj {
  position: fixed;
  top: 50%;
  left: 50%;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.65);
  z-index: 99;
  transform: translate(-50%, -50%);
}

.container-gd {
  /* padding: 17px 28px; */
  position: fixed;
  top: 50%;
  left: 50%;
  width: 780px;
  /* height: 600px; */
  background: #ffffff;
  z-index: 99;
  transform: translate(-50%, -50%);
  overflow: hidden;
  border-radius: 10px;
}

.container-gd::-webkit-scrollbar {
  display: none;
}

.header {
  width: 100%;
  height: 55px;
  border-bottom: 1px solid #e7e7e7;
  position: relative;

  p {
    font-size: 18px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  i {
    font-size: 20px;
    font-weight: 500;
    color: #333333;
    position: absolute;
    top: 50%;
    right: 10px;
    transform: translateY(-50%);
  }
}

.type-list {
  padding: 0 20px;
  box-sizing: border-box;
  display: flex;
  flex-wrap: wrap;
}

.type-item-active {
  padding: 5px 13px;
  line-height: 20px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.type-item-inactive {
  padding: 5px 13px;
  line-height: 20px;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #1877ff;
  margin-right: 10px;
  margin-top: 10px;
  cursor: pointer;
}

.item-container {
  padding: 0 20px;
  margin-top: 10px;
  box-sizing: border-box;
  height: 480px;
  overflow: hidden;
  overflow-y: auto;
}

.confirm-btn {
  width: 89px;
  height: 38px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  line-height: 38px;
  cursor: pointer;
  margin: 10px auto;
}

.type-div {
  width: 68px;
  height: 38px;
  background: #1877ff;
  border: 1px solid #1877ff;
  border-radius: 4px;
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC, PingFang SC-Medium;
  font-weight: Medium;
  text-align: center;
  color: #ffffff;
  line-height: 38px;
}
</style>



// WEBPACK FOOTER //
// src/components/LibraryEditDialog/index.vue